import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

const changeKindListener = () => {
    const changeKindTriggerElements = document.querySelectorAll('.js-change-kind-gender');

    changeKindTriggerElements.forEach((el) => {
        el.addEventListener('change', () => {
            const changeKindValue = el.value;
            const changeKindElements = [
                ...document.querySelectorAll('.js-change-kind-gender-container'),
            ];

            changeKindElements.forEach((ell) => {
                ell.classList.add('d-none');
                toggleAllInputsInContainer(ell, false);
            });

            const elementsToEnable = changeKindElements.filter((ell) =>
                ell.dataset.gender.split(',').find((elll) => elll === changeKindValue)
            );

            elementsToEnable.forEach((ell) => {
                ell.classList.remove('d-none');
                toggleAllInputsInContainer(ell, true);
            });
        });
    });
};

const selectOldSizeValues = (product) => {
    const hidden = {
        ring_previous_size: product.options.find(
            (option) => option.product_option.option.slug === 'size'
        ),
        previous_female_size: product.options.find(
            (option) => option.product_option.option.slug === 'female_size'
        ),
        previous_male_size: product.options.find(
            (option) => option.product_option.option.slug === 'male_size'
        ),
        ring_previous_half_size: product.options.find(
            (option) => option.product_option.option.slug === 'half_size'
        ),
        female_previous_half_size: product.options.find(
            (option) => option.product_option.option.slug === 'female_half_size'
        ),
        male_previous_half_size: product.options.find(
            (option) => option.product_option.option.slug === 'male_half_size'
        ),
    };

    const select = {
        ring_previous_size: product.options.find(
            (option) => option.product_option.option.slug === 'size'
        ),
        previous_female_size: product.options.find(
            (option) => option.product_option.option.slug === 'female_size'
        ),
        previous_male_size: product.options.find(
            (option) => option.product_option.option.slug === 'male_size'
        ),
    };

    const checkbox = {
        ring_previous_half_size: product.options.find(
            (option) => option.product_option.option.slug === 'half_size'
        )?.product_option_value,
        female_previous_half_size: product.options.find(
            (option) => option.product_option.option.slug === 'female_half_size'
        )?.product_option_value,
        male_previous_half_size: product.options.find(
            (option) => option.product_option.option.slug === 'male_half_size'
        )?.product_option_value,
    };

    Object.keys(select).forEach((key) => {
        const elements = document.querySelectorAll(`select[name="${key}"]`);

        elements.forEach((el) => {
            el.value = select[key]?.value;
        });
    });

    Object.keys(checkbox).forEach((key) => {
        const elements = document.querySelectorAll(`input[type="checkbox"][name="${key}"]`);

        elements.forEach((el) => {
            el.checked = !!checkbox[key];
        });
    });

    Object.keys(hidden).forEach((key) => {
        const elements = document.querySelectorAll(`input[type="hidden"][name="${key}"]`);

        elements.forEach((el) => {
            el.value = hidden[key]?.value || '';
        });
    });
};

const sizeChangeElements = [...document.querySelectorAll('.js-size-change-element')];

window.addEventListener('old-model-set', (e) => {
    if (window.returnsFormData.serviceType !== 'service_size_change') {
        return;
    }

    const { productType, product } = e.detail;

    sizeChangeElements.forEach((el) => {
        el.classList.add('d-none');
        toggleAllInputsInContainer(el, false);
    });

    const elementsToEnable = sizeChangeElements.filter(
        (el) => el.dataset.productType === productType
    );

    elementsToEnable.forEach((el) => {
        el.classList.remove('d-none');
        toggleAllInputsInContainer(el, true);
    });

    console.log(product);
    selectOldSizeValues(product);
});

const sizeChangeAlertListener = () => {
    const sizeChangeSelectElements = [
        ...document.querySelectorAll('.js-return-size-change'),
    ].filter((el) => !el.sizeChangeAlertInitialized);
    const sizeChangeAlert = document.querySelector('.js-size-change-alert');

    const shouldBeShownAlert = () =>
        sizeChangeSelectElements.some((el) => {
            console.log({ el });

            const correspondingPreviousSize = document.querySelector(
                el.dataset.previousSizeSelector
            );

            console.log({ correspondingPreviousSize }, el.dataset.previousSizeSelector);

            return Math.abs(correspondingPreviousSize.value - el.value) > 3;
        });

    sizeChangeSelectElements.forEach((el) => {
        el.addEventListener('change', () => {
            if (shouldBeShownAlert()) {
                sizeChangeAlert.classList.remove('d-none');
            } else {
                sizeChangeAlert.classList.add('d-none');
            }
        });
        el.sizeChangeAlertInitialized = true;
    });
};

changeKindListener();
sizeChangeAlertListener();
